import { React, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";

function StrongAuthOptionsPage() {
  const basePath = process.env.PUBLIC_URL;
  const baseEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const navigate = useNavigate();
  const location = useLocation();
  const [isTAP, setIsTap] = useState(true);
  const [isDisclaimerChecked, setIsDisclaimerChecked] = useState(false);
  const [isMultiUseTap, setIsMultiUseTap] = useState(false);
  const [selectedPurpose, setSelectedPurpose] = useState("authSetup");
  const handlePurposeChange = (purpose, usableOnce) => {
    setSelectedPurpose(purpose);
    setIsMultiUseTap(usableOnce);
  };
  const [apiError, setApiError] = useState({
    errorMessage: "",
    error: "",
  });
  const [mfaapiError, setmfaApiError] = useState({
    errorMessage: "",
    error: "",
  });
  const csrfToken = document.cookie.replace(
    /(?:(?:^|.*;\s*)XSRF-TOKEN\s*\=\s*([^;]*).*$)|^.*$/,
    "$1"
  );
  const checkIfNonceIsMapped = (inputType, usableOnce) => {
    let tapormfa = inputType ? "TAP" : "MFA";
    setApiError({
      ...apiError,
      error: true,
    });
    axios.defaults.withCredentials = true;
    axios
      .get(
        baseEndPoint + "nonce/check/" + tapormfa,
        {},
        {
          withCredentials: true,
          headers: {
            "X-CSRF-TOKEN": csrfToken,
          },
        }
      )
      .then((res) => {
        setApiError({
          ...apiError,
          error: false,
        });
        if (tapormfa === "MFA") {
          generateRegisterCode(res.data);
        } else {
          generatePasscode(res.data, usableOnce);
        }
      })
      .catch((err) => {
        if (err.code == "ERR_BAD_REQUEST") {
          setApiError({
            ...apiError,
            errorMessage: "Verification code generation failed.",
          });
        }
        if (err.code == "ERR_NETWORK") {
          setApiError({
            ...apiError,
            errorMessage: "Network Error",
          });
        }
      });
  };

  const generatePasscode = (serverResponse, usableOnce) => {
    if (serverResponse) {
      navigate(basePath + "/verifyCode", {
        state: {
          isMultiUseTap: usableOnce,
        },
      });
    } else if (location?.state?.groupCheckPassed) {
      navigate(basePath + "/generateCodeOptions", {
        state: {
          LMEmail: location?.state?.LMEmail,
          country: location?.state?.country,
          newUser: location?.state?.newUser,
          isMultiUseTap: usableOnce,
        },
      });
    } else {
      navigate(basePath + "/generateCode", {
        state: {
          LMEmail: location?.state?.LMEmail,
          nonceValid: location?.state?.nonceValid,
          groupCheckPassed: location?.state?.groupCheckPassed,
          isMultiUseTap: usableOnce,
        },
      });
    }
  };
  const generateRegisterCode = (serverResponse) => {
    if (serverResponse) {
      navigate(basePath + "/registerverifycode", {});
    } else {
      navigate(basePath + "/registermicrosoftauth", {
        // adding save data here

        state: {
          LMEmail: location?.state?.LMEmail,
          nonceValid: location?.state?.nonceValid,
          groupCheckPassed: location?.state?.groupCheckPassed,
        },
      });
    }
  };

  const setSpinner = () => {
    if (apiError.error) {
      return <div className="padding-span margin-left20 loading small"></div>;
    } else {
      return (
        <span className="padding-span">
          <span
            className={apiError.errorMessage ? "margin-left20 red-icon" : ""}
          >
            {apiError.errorMessage}
          </span>
        </span>
      );
    }
  };

  const onChangeRadioValue = (e) => {
    // By Default TAP is selected and isTAP is true
    if (e.currentTarget.id == "rbtn2") {
      setIsTap(false);
    } else {
      setIsTap(true);
    }
  };
  return (
    <div className="row captcha_container">
      <div className="tile xl-4 lg-3 sm-12"></div>
      <div className="xl-4 lg-6 sm-12">
        <div className="card">
          <div className="header sm-12">
            <div className="left">
              <div className="title">Step 2 </div>
            </div>
          </div>
          <br />
          <div className="tile">
            <b>
              Select a Temporary Access Pass (TAP) for your scenario:
            </b>
            <br />
            <div style={{ paddingLeft: "4px" }}>
              <div className="tile">
                <input
                  id="purpose1"
                  name="tapPurpose"
                  type="radio"
                  value="authSetup"
                  checked={selectedPurpose === "authSetup"}
                  onChange={() => handlePurposeChange("authSetup", false)}
                />
                <label htmlFor="purpose1">
                  <b>Set up Authentication method(s)</b><br></br>
                  Registering or re-registering authentication methods such as Microsoft Authenticator or Passkeys.
                </label>
              </div>
              <div className="tile">
                <input
                  id="purpose2"
                  name="tapPurpose"
                  type="radio"
                  value="laptopEnroll"
                  checked={selectedPurpose === "laptopEnroll"}
                  onChange={() => handlePurposeChange("laptopEnroll", false)}
                />
                <label htmlFor="purpose2">
                  <b>Enroll a new MWP laptop</b><br></br>
                  Use this option for first-time sign-in and setup of a company-provided MWP laptop.
                </label>
              </div>
              <div className="tile">
                <input
                  id="purpose3"
                  name="tapPurpose"
                  type="radio"
                  value="mobileEnroll"
                  checked={selectedPurpose === "mobileEnroll"}
                  onChange={() => handlePurposeChange("mobileEnroll", true)}
                />
                <label htmlFor="purpose3">
                  <b>Enroll a mobile device in Mobile Workplace (EMM)</b><br></br>
                  Use this option to enroll your company-provided mobile device in Mobile Workplace (EMM).
                </label>
              </div>
            </div>
            <div style={{ marginBottom: "8px" }}>
              <b>
                Disclaimer:
              </b>
            </div>
            <div className="disclaimer-ack-box">
              <input
                type="checkbox"
                id="disclaimer"
                checked={isDisclaimerChecked}
                onChange={(e) => setIsDisclaimerChecked(e.target.checked)}
              />
              <label htmlFor="disclaimer">
                I understand that Temporary Access Pass (TAP) is monitored and must be used only for device enrollment or authentication method(s) registration. Misuse will result in a security incident.
              </label>
            </div>
            <br />
          </div>
          <div className="tile">
            <input
              id="rbtn1"
              name="group1"
              type="radio"
              value="tap"
              checked={isTAP}
              onChange={onChangeRadioValue}
            />
            <label htmlFor="rbtn1">Generate Temporary Access Passcode</label>
          </div>
          <div className="row tile margin-top20">
            <button
              className="btn primary"
              onClick={(e) => checkIfNonceIsMapped(isTAP, isMultiUseTap)}
              disabled={!isTAP || !isDisclaimerChecked}
            >
              Next
            </button>
            {setSpinner()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StrongAuthOptionsPage;
